import { ifProp } from 'src/shared/styled-utils/ifProp';
import styled from 'styled-components';
import { Border, Colors, Font, Mixins, Spacing } from 'web-common/src/shared/styles';

const CARD_WIDTH_HEIGHT = '104px';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  font-family: ${Font.Family.SANS};
  position: relative;
  align-items: center;
  padding: ${Spacing.SINGLE_QUARTER} ${Spacing.SINGLE};
  background: ${Colors.WHITE};
  border: ${Border.Base} ${Colors.GRAY_LITE_20};
  border-radius: ${Border.Radius.M};
  cursor: pointer;
  text-align: center;
  ${Mixins.Shape.squareForcedMinDimensions(CARD_WIDTH_HEIGHT)}
  ${Mixins.Media.minWidthMedium('min-width: calc((100% - 80px) / 6);')}
`;

export const FilterIcon = styled.div<{ coloredIcon?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background: ${ifProp('coloredIcon', Colors.KOHLRABI_LITE_30, 'transparent')};
  border-radius: ${Spacing.DOUBLE};
  ${Mixins.Shape.square(Spacing.DOUBLE_HALF)}
  & svg {
    ${Mixins.Shape.square(Spacing.SINGLE_HALF)}
  }

  ${Mixins.Media.maxWidthSmall(`
    border-radius: ${Spacing.TRIPLE};
    ${Mixins.Shape.square(Spacing.TRIPLE)}
  `)}
`;

export const FilterName = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  flex-grow: 1;
  max-width: 100%;
  padding-top: ${Spacing.HALF};

  font-size: ${Font.Size.XXS};
  font-weight: ${Font.Weight.BOLD};
  ${Mixins.Text.overflow(1)}
`;
